import type {
  PaymentMethodT,
  SubscriptionUpdatePreviewT,
} from '@mentimeter/billing';
import {
  trackAddLicenses,
  trackChangeBillingCycle,
  trackPlanUpgrade,
} from '@mentimeter/google-tracking';
import type { CheckoutModalType } from '../types';

const googleTrackingEventMap = {
  plan: trackPlanUpgrade,
  licenses: trackAddLicenses,
  'billing-cycle': trackChangeBillingCycle,
};

export function trackPurchase(
  type: CheckoutModalType,
  numberOfLicenses: number,
  invoicePreview: SubscriptionUpdatePreviewT,
  paymentMethod: PaymentMethodT,
  userId: number | undefined,
  requestId: string,
) {
  const numberOfLicensesAdded =
    numberOfLicenses - invoicePreview.prorationItem.quantity;

  const isAdditionalLicenses = type === 'licenses';
  const quantity = isAdditionalLicenses
    ? numberOfLicensesAdded
    : numberOfLicenses;
  const pricePerLicense = invoicePreview.totalExclTax / quantity;
  const itemPrice = pricePerLicense / invoicePreview.subUnitToUnit;
  const totalPriceExclTax =
    invoicePreview.totalExclTax / invoicePreview.subUnitToUnit;

  // we want a unique id for each purchase, but also a way to lookup what purchase it is
  const id = requestId + '-' + (userId ? userId?.toString() : '');

  const trackEvent = googleTrackingEventMap[type];
  trackEvent({
    transaction_id: id,
    value: totalPriceExclTax,
    currency: invoicePreview.currency,
    item_name: invoicePreview.purchaseItem.category,
    item_price: itemPrice,
    quantity,
    payment_method: paymentMethod?.type,
  });

  return;
}
